import React, { useContext, useState, useEffect, useCallback } from 'react';
import { Item, Button, Label, Segment, Table, Menu, Icon, Container, Grid, Popup, Confirm, Header, Progress } from 'semantic-ui-react';
import { observer } from 'mobx-react-lite';
import TechnicianProjectStore from '../../app/stores/technicianprojectStore';
import PhotoDropzone from '../../app/common/Dropzone/PhotoDropzone';
import LoadingComponent from '../../app/layout/LoadingComponent';
import { RouteComponentProps } from 'react-router-dom';

interface DetailParams {
  id: string;
}

const ProjectPhotoUpload : React.FC<RouteComponentProps<DetailParams>> = ({
  match,
  history
}) => {
  const technicianprojectStore = useContext(TechnicianProjectStore);
  const {loadPhotoUploads, photouploadsByName, photouploadCount, uploadingFile, loadProject, technicianproject} = technicianprojectStore;
  
  useEffect(() => {
    loadPhotoUploads(match.params.id);
    loadProject(match.params.id);
  }, []);

  if (!technicianproject) return <LoadingComponent content='Loading project...' />

  return (
    <div>
    <span>Address: {technicianproject.address} </span>
      <Table celled unstackable size='small'>
    <Table.Header>
      <Table.Row>
        <Table.HeaderCell width={1}>Equipment Name</Table.HeaderCell>
        <Table.HeaderCell>Photo Request</Table.HeaderCell>
        <Table.HeaderCell width={1}>Photos Uploaded</Table.HeaderCell>
        <Table.HeaderCell width={1}>Upload</Table.HeaderCell>
      </Table.Row>
    </Table.Header>

    <Table.Body>
    {photouploadsByName.map(photo => (
      <Table.Row key={photo.name}>
        <Table.Cell>
          <Label>{photo.name}</Label>
        </Table.Cell>
        <Table.Cell>{photo.request.map(function(d: any){
         return (<div>*{d}</div>)
       })}</Table.Cell>
        <Table.Cell>{photouploadCount.get(photo.name)} photo</Table.Cell>
        <Table.Cell>
        <Button
                  size='mini'
                    color="grey"
                    content={<PhotoDropzone name={photo.name} category='Project'/>}
                />
        </Table.Cell>
      </Table.Row>
    ))}
    </Table.Body>
  </Table>
  </div>
  );
};

export default observer(ProjectPhotoUpload);
